import React from 'react';
import { Typography } from '@axafr-btc-ds/typography';
import { ColorToken } from '@axafr-btc-ds/colors';
/**
 * Return subLabel if is defined.
 *
 * @param {string} subLabel - Text subLabel.
 */
export var SubLabel = function (_a) {
    var subLabel = _a.subLabel;
    return !!subLabel
        ? React.createElement(React.Fragment, null,
            "\u00A0",
            React.createElement(Typography, { variant: "body2", color: ColorToken.textPlaceholder }, subLabel))
        : null;
};
export var Option = function (_a) {
    var label = _a.label, subLabel = _a.subLabel, value = _a.value;
    return (React.createElement("option", { label: label, value: value }, ("" + label + (subLabel ? " - " + subLabel : '')).trim()));
};
export var SelectLabel = function (_a) {
    var label = _a.label, subLabel = _a.subLabel, value = _a.value;
    return (React.createElement(Typography, { variant: "body2", className: "axa-form-select-text", color: !value ? ColorToken.textPlaceholder : ColorToken.textSecondary },
        React.createElement("span", null,
            label,
            "\u00A0",
            React.createElement(SubLabel, { subLabel: subLabel }))));
};
